export default [
    {
        path: 'convenio-medico',
        component: () => import(
            /* webpackChunkName: 'cadastro-convenio-medico' */
            '@/views/cadastro/convenio-medico/Index'
        ),
        redirect: 'convenio-medico/index',
        children: [
            {
                name: 'cadastro-convenio-medico-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-convenio-medico' */
                    '@/views/cadastro/convenio-medico/List.vue'
                ),
            },
            {
                name: 'cadastro-convenio-medico-create',
                path: 'create',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-convenio-medico' */
                    '@/views/cadastro/convenio-medico/Form.vue'
                ),
            },
            {
                name: 'cadastro-convenio-medico-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-convenio-medico' */
                    '@/views/cadastro/convenio-medico/Form.vue'
                ),
            },
        ],
    },
]